import * as React from "react";
const SvgSyncCloud02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.293 15.793a1 1 0 1 1 1.414 1.414L8.414 18.5H14.5a1 1 0 1 1 0 2H8.414l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414zm5.5-6a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414l1.293-1.293H9a1 1 0 1 1 0-2h6.086l-1.293-1.293a1 1 0 0 1 0-1.414M1 10.5a8.5 8.5 0 0 1 15.714-4.495 6.499 6.499 0 0 1 4.8 10.632 1 1 0 0 1-1.542-1.274A4.5 4.5 0 0 0 16.5 8a1.62 1.62 0 0 1-1.396-.795 6.5 6.5 0 1 0-10.209 7.883 1 1 0 0 1-1.416 1.411A8.48 8.48 0 0 1 1 10.5"
}));
export default SvgSyncCloud02;
//# sourceMappingURL=SyncCloud02.js.map